import React from 'react';
import Helmet from 'react-helmet';
import { PrismicImage } from 'types/prismicImage';

interface ISeoProps {
  title: string;
  description?: string;
  image?: PrismicImage;
}

export const Seo = ({ title, description, image }: ISeoProps) => {
  const meta = [];

  if (title) {
    meta.push({ property: 'og:title', content: title }, { name: 'twitter:title', content: title });
  }

  if (description) {
    meta.push(
      { name: 'description', content: description },
      { property: 'og:description', content: description },
      { name: 'twitter:description', content: description }
    );
  }

  if (image) {
    meta.push(
      { property: 'og:image', content: image.url },
      { name: 'twitter:image', content: image.url }
    );

    if (image.dimensions) {
      meta.push(
        { property: 'og:image:width', content: `${image.dimensions.width}px` },
        { property: 'og:image:height', content: `${image.dimensions.height}px` }
      );
    }

    if (image.alt) {
      meta.push({ property: 'og:image:alt', content: image.alt });
    }
  }

  return <Helmet title={title} meta={meta} />;
};
